import React from 'react';

export const useScrollLock = (): { lock: () => void; unlock: () => void; } => {
    const lock = React.useCallback(
        () => {
            const scrollBarCompensation = window.innerWidth - document.body.offsetWidth;

            document.body.dataset.scrollLock = 'true';
            document.body.style.setProperty('width', `calc(100% - ${scrollBarCompensation}px)`);
        }, []);

    const unlock = React.useCallback(
        () => {
            document.body.style.overflow = '';
            document.body.style.width = '100%';
            delete document.body.dataset.scrollLock;
        }, []);

    return {
        lock,
        unlock
    };
};
